const actions = {
  SET_STATE: "widgetChannelState/SET_STATE",
  LIST: "widgetChannelState/LIST",
  CREATE: "widgetChannelState/CREATE",
  DETAIL: "widgetChannelState/DETAIL",
  UPDATE: "widgetChannelState/UPDATE",
  DELETE: "widgetChannelState/DELETE",
};

export default actions;
